import { Star, ArrowUpRight } from "lucide-react";

const GOOGLE_URL =
  "https://www.google.com/maps/search/?api=1&query=Flavio's+House+Of+Hair+Design+1900+Dundas+St+W+Mississauga";

const REVIEWS = [
  {
    name: "Tina Reale",
    text: "Fabulous cut, hair color & style. Every time. Flavio's takes good care of their clients. You won't be disappointed!",
  },
  {
    name: "Violet Greer",
    text: "Literally the BEST salon I've ever been to! No matter who does your hair, you will always be happy with it :) today I had the best experience by far — this salon has taken away all anxiety when it comes to getting my hair done.",
  },
  {
    name: "Leanne Snodgrass",
    text: "Always a great experience at Flavio's! Recently my 3yr old daughter and I got our hair cut at the same time and the team well took care of us. Beyond both getting great haircuts, they made my daughter feel super comfortable on her own and made sure she was set up well with a snack and hot chocolate while she waited for my cut to finish. Thank you!!!",
  },
];

const Stars = ({ className = "" }) => (
  <div className={`flex items-center gap-1 ${className}`}>
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-gold text-gold" />
    ))}
  </div>
);

export default function Reviews() {
  return (
    <section
      data-testid="reviews-section"
      className="relative bg-ink-900 text-sand-50 py-24 lg:py-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <span className="overline !text-gold">Loved On Google</span>
            <h2 className="mt-6 font-serif font-light text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Rated <span className="italic text-gold">4.8</span> by our guests.
            </h2>
            <div className="mt-6 flex items-center gap-4">
              <Stars />
              <span className="text-xs tracking-[0.2em] uppercase text-sand-300/70">
                Google Reviews
              </span>
            </div>
          </div>
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-google-link"
            className="inline-flex items-center gap-2 border border-sand-50/25 px-6 py-3.5 text-xs tracking-[0.2em] uppercase hover:bg-sand-50 hover:text-ink-900 transition-colors duration-300 w-fit"
          >
            Read All Reviews on Google
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-sand-50/10">
          {REVIEWS.map((r, i) => (
            <blockquote
              key={r.name}
              data-testid={`review-card-${i}`}
              className="bg-ink-900 p-8 lg:p-10 flex flex-col gap-6"
            >
              <Stars />
              <p className="font-serif italic text-xl lg:text-2xl leading-snug text-sand-50/90">
                &ldquo;{r.text}&rdquo;
              </p>
              <footer className="mt-auto flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-gold/20 text-gold flex items-center justify-center font-serif text-lg">
                  {r.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm text-sand-50">{r.name}</p>
                  <p className="text-[0.65rem] tracking-[0.2em] uppercase text-sand-300/60">
                    Google Review
                  </p>
                </div>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
